<template>
  <div>
    <populate-form
      formTitle="店家劃位設定管理"
      fkey="mm01"
      ref="filterStoreForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      :validatePrompt="false"
      :parentVue="this"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div v-if="StoreSetting">
      <div v-if="!inEditMode">
        <b-button v-if="StoreRuleIsSet" @click="setStoreSetting">查看/編輯詳細設定</b-button>
        <b-button v-if="!StoreRuleIsSet" @click="setStoreSetting">建立新設定</b-button>

      </div>
      <div v-if="inEditMode">
        <b-button @click="inEditMode=false">取消</b-button>
        <b-button @click="saveStoreRule">保存</b-button>
        

      </div>
    </div>
    <div v-if="!StoreSetting">
      請先用關鍵字找到店家
    </div>
  </div>
</template>

<script>

import StoreInfo from './StoreInfo'

export default {
  name: 'StoreManage',
  components: {
    /* eslint-disable vue/no-unused-components */
    StoreInfo,
  },
  data: function () {
    return {
      showModal:false,
      inEditMode:false,
      Stores:[],
      StoreSetting:null,
      filterData: {},
      filterOptions:[
        {
          componentType:'vue-single-select',
          optionVar:'Stores',
          asyncFetchCB: this.loadStoreByKeyword,
          defaultValue:null,
          akey:'SelectedStoreItem',
          optionLabel:'select_text',
          col:12,
          placeholder:'選擇店家(輸入至少一個字的店家名稱關鍵字或SPS編號帶出選項,按Esc可清除全部關鍵字)',
        },
      ]
    }
  },
  methods: {
    closePopup () {
      this.showModal = false
      this.popupItem = ""
    },
    setStoreSetting() {
      //新增一個店家的劃位設定
      this.inEditMode = true
    },
    loadStoreByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Stores = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getStoreAutoComplete',
        'keyword':keyword,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Stores = data.data.matched_store_list
      },this)
    },
    filterChanged (upd) {
      if (upd.key === 'SelectedStoreItem') {
        if (upd.val) {
              setTimeout(() => {
            this.loadStoreSettings(upd.val.id)
          }, 50);
        }
        else {
          this.StoreSetting = null
        }
      }
      
    },
    loadStoreSettings(store_id) {
      let Param = {
        'module':'store_admin',
        'method':'getStoreServiceRuleByStoreId',
        'store_id':store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.StoreSetting = data.data
      },this)
    }
  },
  computed:{
    StoreRuleIsSet: {
      cache: false,
      get () {
        if (this.StoreSetting && this.StoreSetting.hasOwnProperty('id')) {
          return true
        }
        else {
          return false
        }
      }
    },
  },
  created () {
    if (!this.$bus.session) {
      this.$bus.session = undefined
    }
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
